import {Component, HostBinding, HostListener, Input, OnInit} from '@angular/core';
import {HeaderService} from "../../../../services/header/header.service";
import {HeaderConfig} from "../../../../models/HeaderConfig";
import {environment} from "../../../../../environments/environment";
import {takeUntil} from "rxjs/operators";
import {Router} from "@angular/router";
import {AuthenticationService} from "../../../../auth/service";
import {CoreConfigService} from "../../../../../@core/services/config.service";
import {CoreMediaService} from "../../../../../@core/services/media.service";
import {CoreSidebarService} from "../../../../../@core/components/core-sidebar/core-sidebar.service";
import {MediaObserver} from "@angular/flex-layout";
import {TranslateService} from "@ngx-translate/core";
import {Subject} from "rxjs";
import {User} from "../../../../auth/models";
import * as _ from 'lodash';
import {StationService} from "../../../../services/station.service";
import {AppNotificationsService, AppNotificationItem} from "../../../../services/app-notifications/app-notifications.service";
import {EnterpriseBrandingService} from "../../../../services/enterprise-branding.service";
import {getEnterpriseNameFromStation} from "../../../../services/enterprise-context";
import {getErpJwtToken} from "../../../../services/auth/erp-auth-token.util";
import {LogicielCaisseFrontLinkService} from "../../../../services/logiciel-caisse/logiciel-caisse-front-link.service";
import {LogicielCaisseAuthService} from "../../../../services/logiciel-caisse/logiciel-caisse-auth.service";
import {AuthSyncService} from "../../../../services/auth/auth-sync.service";
import {ModuleNavigationService} from "../../../../services/module-navigation/module-navigation.service";

@Component({
  selector: 'app-title-section',
  templateUrl: './title-section.component.html',
  styleUrls: ['./title-section.component.scss']
})
export class TitleSectionComponent implements OnInit {

    file: string = environment.file_url;
    file_url: string = environment.url_images;
    public horizontalMenu: boolean;
    public hiddenMenu: boolean;

    public coreConfig: any;
    public currentSkin: string;
    public prevSkin: string;
    public currentTheme: string = 'light'; // 'light', 'dark', or 'system'

    public currentUser: User;
    public currentStation: any;
    public allStations: any[] = [];
    /** Détails de la station chargés depuis GET /api/settings/station/:station_id (coordonnees avec prenom, nom). */
    public currentStationDetails: any = null;

    public languageOptions: any;
    public navigation: any;
    public selectedLanguage: any;

    @HostBinding('class.fixed-top')
    public isFixed = false;

    @HostBinding('class.navbar-static-style-on-scroll')
    public windowScrolled = false;

    // Add .navbar-static-style-on-scroll on scroll using HostListener & HostBinding
   // @HostListener('window:scroll', [])
  config$ = this.headerService.config$;
    private _unsubscribeAll: Subject<any> = new Subject();

  constructor(private headerService: HeaderService,   private _router: Router,
              private _authenticationService: AuthenticationService,
              private _coreConfigService: CoreConfigService,
              private _coreMediaService: CoreMediaService,
              private _coreSidebarService: CoreSidebarService,
              private _mediaObserver: MediaObserver,
              public _translateService: TranslateService,
              private stationService: StationService,
              private appNotifications: AppNotificationsService,
              private enterpriseBranding: EnterpriseBrandingService,
              private logicielCaisseFrontLink: LogicielCaisseFrontLinkService,
              private logicielCaisseAuth: LogicielCaisseAuthService,
              private authSync: AuthSyncService,
              private moduleNavigation: ModuleNavigationService) {}

    markAllNotificationsRead(): void {
        this.appNotifications.markAllRead();
    }

    onNotificationClick(n: AppNotificationItem): void {
        if (!n.read) {
            this.appNotifications.markRead(n.id).subscribe();
        }
    }

    removeNotification(id: string | number, event: MouseEvent): void {
        event.stopPropagation();
        this.appNotifications.remove(id, event);
    }

    clearAllNotifications(event: MouseEvent): void {
        event.stopPropagation();
        this.appNotifications.clearAll();
    }

    /** Icône Bootstrap Icons selon le type de notification (stock, alerte, défaut). */
    getNotificationIconClass(type: string | undefined): string {
        const t = (type || '').toLowerCase();
        if (t.includes('stock')) {
            return 'bi bi-box-seam';
        }
        if (t.includes('alert') || t.includes('alerte')) {
            return 'bi bi-exclamation-triangle';
        }
        return 'bi bi-bell';
    }

    /** Modificateur de couleur pour le pastille d’icône. */
    getNotificationIconVariant(type: string | undefined): string {
        const t = (type || '').toLowerCase();
        if (t.includes('stock')) {
            return 'app-notification-item-icon--stock';
        }
        if (t.includes('alert') || t.includes('alerte')) {
            return 'app-notification-item-icon--alert';
        }
        return 'app-notification-item-icon--default';
    }

    get notifications$() {
        return this.appNotifications.items$;
    }

    get unreadCount$() {
        return this.appNotifications.unreadCount$;
    }

    /** Route section « données » : masquer l’icône base de données redondante dans la barre. */
    get isParametreDonneesSection(): boolean {
        const u = this._router.url || '';
        return u.includes('/main/parametre/donnees');
    }

    toggleDarkSkin() {
        // Get the current skin
        this._coreConfigService
            .getConfig()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(config => {
                this.currentSkin = config.layout.skin;
            });

        // Toggle Dark skin with prevSkin skin
        this.prevSkin = localStorage.getItem('prevSkin');

        if (this.currentSkin === 'dark') {
            this._coreConfigService.setConfig(
                { layout: { skin: this.prevSkin ? this.prevSkin : 'default' } },
                { emitEvent: true }
            );
        } else {
            localStorage.setItem('prevSkin', this.currentSkin);
            this._coreConfigService.setConfig({ layout: { skin: 'dark' } }, { emitEvent: true });
        }
    }

    ngOnInit() {
        // get the currentUser details from localStorage
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

        // Load stations
        this.loadStations();

        this.appNotifications.loadFromServer().subscribe();

        // Get current skin
        this._coreConfigService
            .getConfig()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(config => {
                this.currentSkin = config.layout.skin;
            });

        // Set the selected language from default languageOptions
        this.selectedLanguage = _.find(this.languageOptions, {
            id: this._translateService.currentLang
        });
    }

    loadTheme() {
        if (this.currentTheme === 'system') {
            // Detect system preference
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            const systemTheme = prefersDark ? 'dark' : 'light';
            this.applyTheme(systemTheme);
        } else {
            this.applyTheme(this.currentTheme);
        }
    }

    setTheme(theme: string) {
        this.currentTheme = theme;
        localStorage.setItem('theme', theme);
        this.loadTheme();
    }

    applyTheme(theme: string) {
        this.prevSkin = localStorage.getItem('prevSkin');
        
        if (theme === 'dark') {
            if (this.currentSkin !== 'dark') {
                localStorage.setItem('prevSkin', this.currentSkin);
            }
            this._coreConfigService.setConfig({ layout: { skin: 'dark' } }, { emitEvent: true });
        } else {
            const prevSkin = localStorage.getItem('prevSkin');
            this._coreConfigService.setConfig(
                { layout: { skin: prevSkin ? prevSkin : 'default' } },
                { emitEvent: true }
            );
        }
    }

    getThemeIcon(): string {
        if (this.currentTheme === 'system') {
            return 'icon-monitor';
        }
        return this.currentSkin === 'dark' ? 'icon-sun' : 'icon-moon';
    }

    loadStations() {
        if (this.currentUser && this.currentUser.stations) {
            this.allStations = this.currentUser.stations;
            // Get current station (first one by default, or the one marked as connected)
            this.currentStation = this.allStations.find(s => s.isConnecte === 1) || this.allStations[0] || null;
            this.enterpriseBranding.setName(getEnterpriseNameFromStation(this.currentStation));
            this.loadStationDetails();
        }
    }

    /** Charge les détails de la station (GET /api/settings/station/:station_id) pour coordonnees.prenom/nom. */
    loadStationDetails(): void {
        const stationId = this.currentStation?.station_id ?? this.currentStation?.id;
        if (!stationId) return;
        this.stationService.getStation(stationId).subscribe({
            next: (res) => {
                if (res?.success && res?.station) {
                    this.currentStationDetails = res.station;
                    this.enterpriseBranding.setName(
                        res.station.nom_entreprise || res.station.label || getEnterpriseNameFromStation(this.currentStation)
                    );
                }
            },
            error: () => {}
        });
    }

    switchStation(station: any) {
        if (!station || station.id === this.currentStation?.id) {
            return;
        }

        // Update isConnecte flag for all stations
        this.allStations.forEach(s => {
            s.isConnecte = s.id === station.id ? 1 : 0;
        });

        // Update current station
        this.currentStation = station;

        // Update currentUser in localStorage (conserver le JWT ERP)
        this.currentUser.stations = this.allStations;
        const jwt = getErpJwtToken();
        const stored = { ...this.currentUser, stations: this.allStations };
        if (jwt) {
            (stored as { token?: string }).token = jwt;
        }
        localStorage.setItem('currentUser', JSON.stringify(stored));

        this.logicielCaisseAuth.syncWithErpContext();

        // Reload the page to apply the new station context
        window.location.reload();
    }

    getStationInitials(station: any): string {
        if (!station || !station.label) return 'V';
        const words = station.label.split(' ');
        if (words.length >= 2) {
            return (words[0][0] + words[1][0]).toUpperCase();
        }
        return station.label.substring(0, 2).toUpperCase();
    }

    getStationLogo(station: any): string {
        if (!station || !station.logo) return this.file;
        // If logo is a full URL, return it as is, otherwise prepend the file_url
        if (station.logo.startsWith('http://') || station.logo.startsWith('https://')) {
            return station.logo;
        }
        return `${this.file_url}${station.logo}`;
    }

    getUserFullName(): string {
        if (!this.currentUser) return 'Utilisateur';
        const u = this.currentUser as any;
        const prenom = u.prenom || u.firstName || '';
        const nom = u.nom || u.lastName || '';
        const full = `${prenom} ${nom}`.trim();
        if (full) return full;
        if (u.nom_prenom) return String(u.nom_prenom).trim();
        return 'Utilisateur';
    }

    getUserInitials(): string {
        if (!this.currentUser) return 'U';
        const u = this.currentUser as any;
        const prenom = (u.prenom || u.firstName || '').toString().trim();
        const nom = (u.nom || u.lastName || '').toString().trim();
        if (prenom && nom) {
            return (prenom.charAt(0) + nom.charAt(0)).toUpperCase();
        }
        if (prenom) return prenom.substring(0, 2).toUpperCase();
        if (nom) return nom.substring(0, 2).toUpperCase();
        if (u.nom_prenom) return String(u.nom_prenom).trim().substring(0, 2).toUpperCase();
        return 'U';
    }

    getStationIdentifier(): string {
        if (this.currentStation && this.currentStation.label) {
            // You can customize this to return a specific identifier
            return this.currentStation.label.toUpperCase().substring(0, 10);
        }
        return 'NET-6-RPON';
    }

    /** Initiales : 1ère lettre du prénom + 1ère lettre du nom (coordonnees[0]) depuis API station, sinon 1ère lettre nom_entreprise. */
    getEntrepriseFirstLetter(): string {
        const coord = this.currentStationDetails?.coordonnees?.[0];
        if (coord) {
            const prenom = (coord.prenom || '').toString().trim();
            const nom = (coord.nom || '').toString().trim();
            if (prenom || nom) {
                const p = prenom ? prenom.charAt(0).toUpperCase() : '';
                const n = nom ? nom.charAt(0).toUpperCase() : '';
                return (p + n) || 'V';
            }
        }
        if (!this.currentStation) return 'V';
        const name = this.currentStation.nom_entreprise || this.currentStation.label || '';
        const trimmed = (name || '').toString().trim();
        return trimmed.length ? trimmed.charAt(0).toUpperCase() : 'V';
    }

    /** Nom et prénom pour le popup : coordonnees[0] depuis API station (prénom nom), sinon currentUser. */
    getCoordonneeDisplayName(): string {
        const coord = this.currentStationDetails?.coordonnees?.[0];
        if (coord) {
            const prenom = (coord.prenom || '').toString().trim();
            const nom = (coord.nom || '').toString().trim();
            const full = `${prenom} ${nom}`.trim();
            if (full) return full;
        }
        return this.getUserFullName();
    }

    toggleDarkMode(event: any) {
        const isDark = event.target.checked;
        // Update currentTheme based on toggle
        if (isDark) {
            this.currentTheme = 'dark';
            localStorage.setItem('theme', 'dark');
        } else {
            this.currentTheme = 'light';
            localStorage.setItem('theme', 'light');
        }
        this.applyTheme(this.currentTheme);
    }

    logout() {
        this._authenticationService.logout();
        this._router.navigate(['/login']);
    }

    navigateToDevis() {
        this._router.navigate(['/vente/devis/add-devis']);
    }

    navigateToFacture() {
        this._router.navigate(['/vente/facture/add-facture']);
    }

    navigateToFournisseur() {
        this._router.navigate(['/tiers/fournisseurs/add-fournisseur']);
    }

    navigateToClient() {
        this._router.navigate(['/tiers/clients/add-client']);
    }

    navigateToProduit() {
        this._router.navigate(['/produits-services/ajout-produit']);
    }

    navigateToEntreprise() {
        this.openParametre('/main/parametre/entreprise');
    }

    /**
     * Ouvre une page Paramètres sur le front dédié (:4300),
     * sauf si on est déjà dans le module parametre.
     */
    openParametre(routePath: string): void {
        const path = routePath.startsWith('/') ? routePath : `/${routePath}`;
        if ((environment.currentModule || '') === 'parametre') {
            void this._router.navigateByUrl(path);
            return;
        }
        const modules = environment.erpModules || [];
        const parametre = modules.find((m: { id?: string }) => m.id === 'parametre') as
            | { baseUrl?: string }
            | undefined;
        const base = (parametre?.baseUrl || 'https://front-parametrage.agrosilo-solutions.com').replace(/\/$/, '');
        const auth = this.authSync.buildAuthQueryParams();
        const goto = encodeURIComponent(path);
        const authPart = auth ? `auth=${auth}&` : '';
        window.location.href = `${base}/home?${authPart}goto=${goto}`;
    }

    openParametreDonnees(): void {
        const path = '/main/parametre/donnees/produits';
        if ((environment.currentModule || '') === 'parametre_data') {
            void this._router.navigateByUrl(path);
            return;
        }
        const modules = environment.erpModules || [];
        const mod = modules.find((m: { id?: string }) => m.id === 'parametre_data') as
            | { baseUrl?: string }
            | undefined;
        const base = (mod?.baseUrl || 'https://front-paramatrage-donne.agrosilo-solutions.com').replace(/\/$/, '');
        const auth = this.authSync.buildAuthQueryParams();
        const goto = encodeURIComponent(path);
        const authPart = auth ? `auth=${auth}&` : '';
        window.location.href = `${base}/home?${authPart}goto=${goto}`;
    }

    /** Retour au hub (cartes modules). */
    openModulesHub(): void {
        this.moduleNavigation.goToHubHome();
    }

    showLogicielCaisseShortcut(): boolean {
        return this.logicielCaisseFrontLink.canOpenFront();
    }

    openLogicielCaisseFront(): void {
        this.logicielCaisseFrontLink.openConnectedFront();
    }

}
